import { GetTimeFromTimestamp } from '@dave/types';
import { SharepointObject } from '@dave/types/dist/proto/sharepoint/main';

export class SharepointObjectEntity {
    constructor(
        public Id: string = null,
        public Name: string = null,
        public IsFolder: boolean = null,
        public Url: string = null,
        public ThumbnailUrl: string = null,
        public MimeType: string = null,
        public Size: number = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
        public Fields: Map<string,string> = null,
        ) {}
    public static readonly fromBackend = (res: SharepointObject): SharepointObjectEntity => {
        return new SharepointObjectEntity(
            res.Id,
            res.Name,
            res.IsFolder,
            res.Url,
            res.ThumbnailUrl,
            res.MimeType,
            // BE schickt für folder size=0
            !res.IsFolder && res.Size ? +res.Size : null,
            res.CreatedAt ? GetTimeFromTimestamp(+res.CreatedAt) : null,
            res.UpdatedAt ? GetTimeFromTimestamp(+res.UpdatedAt) : null,
            res.Fields ? new Map<string, string>(Object.entries(res.Fields)) : null,
        );
    }
    public Clone(override: Partial<SharepointObjectEntity> = {}): SharepointObjectEntity {
        const attr = { ...this, ...override };
        return Object.assign(new SharepointObjectEntity(), attr);
    }
}
